import type { MailboxInfo } from 'owa-client-types';
import { getApplicationSettings } from 'owa-application-settings';
import { isFeatureEnabled } from 'owa-feature-flags';
import isOptInExperienceEnabledForPrioritize from './isOptInExperienceEnabledForPrioritize';

export default function isPrioritizeEnabled(mailboxInfo: MailboxInfo): boolean {
    // https://ecs.skype.com/Substrate/OutlookWebClient/configurations/1092852
    if (!getApplicationSettings('Copilot', mailboxInfo).prioritizeEnabled) {
        return false;
    }

    // If isOptInExperienceEnabledForPrioritize is FALSE, the user has already
    // opted in to the previous Prioritize experience, so we enable the feature.
    if (!isOptInExperienceEnabledForPrioritize(mailboxInfo)) {
        return true;
    }

    // If isOptInExperienceEnabledForPrioritize is TRUE, the user hasn't opted in yet.
    // We only enable the feature if the tri-prioritize-on-demand flight is ON.
    return isFeatureEnabled('tri-prioritize-on-demand');
}

export function isPrioritizeOnDemandEnabled(mailboxInfo: MailboxInfo): boolean {
    return isPrioritizeEnabled(mailboxInfo) && isFeatureEnabled('tri-prioritize-on-demand');
}

export function isPrioritizeOnDeliveryEnabled(mailboxInfo: MailboxInfo): boolean {
    return isPrioritizeEnabled(mailboxInfo) && !isOptInExperienceEnabledForPrioritize(mailboxInfo);
}
